import { CAMPAIGN_CFG } from '@/configs/campaign-config';

type NavFeatureConfig = {
	visible: boolean;
	enabled: boolean;
	comingSoonLabel?: string;
};

const buildFeatureConfig = ({ visible = true, enabled = true, comingSoonLabel }: Partial<NavFeatureConfig> = {}): NavFeatureConfig => ({
	visible,
	enabled,
	comingSoonLabel,
});

export const NAV_FEATURES = {
	vip: buildFeatureConfig({
		visible: CAMPAIGN_CFG.features.vip.visible !== false,
		enabled: CAMPAIGN_CFG.features.vip.enabled !== false,
		comingSoonLabel: CAMPAIGN_CFG.features.vip.comingSoonLabel,
	}),
	quests: buildFeatureConfig({
		visible: CAMPAIGN_CFG.features.quests.visible !== false,
		enabled: CAMPAIGN_CFG.features.quests.enabled !== false,
		comingSoonLabel: CAMPAIGN_CFG.features.quests.comingSoonLabel,
	}),
	referral: buildFeatureConfig({
		visible: CAMPAIGN_CFG.features.referral.visible !== false,
		enabled: CAMPAIGN_CFG.features.referral.enabled !== false,
		comingSoonLabel: CAMPAIGN_CFG.features.referral.comingSoonLabel,
	}),
	giveaway: buildFeatureConfig({
		visible: CAMPAIGN_CFG.features.giveaway.visible !== false,
		enabled: CAMPAIGN_CFG.features.giveaway.enabled !== false,
		comingSoonLabel: CAMPAIGN_CFG.features.giveaway.comingSoonLabel,
	}),
	weeklyRace: buildFeatureConfig({
		visible: CAMPAIGN_CFG.features.weeklyRace.visible !== false,
	}),
};

export const isNavFeatureEnabled = (feature: keyof typeof NAV_FEATURES) => {
	const config = NAV_FEATURES[feature];
	return config.visible && config.enabled;
};
